import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn } from 'styles/layouts';

export const Wrapper = styled(FlexColumn)`
  border: 1px solid ${themeStyle.varTransparentMain5};
  border-radius: 20px;

  overflow-x: hidden;

  width: 100%;
  max-width: 356px;
  height: 530px;
`;

export const Background = styled.div<{ backgroundImage: string }>`
  box-sizing: border-box;
  box-shadow: ${themeStyle.varShadowSoft};

  background-color: ${themeStyle.varBackgroundBase};
  background-image: ${({ backgroundImage }) => `url("${backgroundImage}")`};
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 50% 50%;

  height: 100%;
  width: 100%;
`;

export const CardContent = styled(FlexColumn)`
  width: 100%;
  height: 100%;
  justify-content: flex-end;

  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 48.49%,
    rgba(0, 0, 0, 0.7) 100%
  );
`;
